import { useNavigate, useLocation } from 'react-router-dom';
import {
  IconButton,
  useTheme,
  Tooltip,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import { useAuth } from '../context/AuthContext';

const BackButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const isAuthenticated = !!user;
  // Check if the current path is the dashboard page
  const isOnDashboard = location.pathname === '/dashboard';
  // If we're on the dashboard, don't render the back button
  if (isOnDashboard) return null;

  const handleGoBack = (e) => {
    e.stopPropagation();
    navigate(-1); // Go to previous page
  };

  return (
    <>
      {isAuthenticated && location.pathname !== '/' && (
        <Tooltip 
          title="Go Back"
        >
          <IconButton
            onClick={handleGoBack}
            sx={{
              position: 'fixed',
              top: 20,
              right: 20,
              zIndex: 1200,
              backgroundColor: 'white',
              boxShadow: 1,
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
              },
            }}
          >
            <ArrowBackIcon />
          </IconButton>
        </Tooltip>
      )}
    </>
  );
};

export default BackButton;